import React, { Component } from 'react'

import withCssClassName from '../with-css-class-name'

class WarningIcon extends Component {
    render() {
        return (
            <svg {...this.props} height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg"><path d="M8 0c4.4 0 8 3.6 8 8s-3.6 8-8 8-8-3.6-8-8 3.6-8 8-8zM7 13h2V7H7v6zm0-8h2V3H7v2z"/></svg>
        )
    }
}

export default withCssClassName(WarningIcon)



// WEBPACK FOOTER //
// src/components/svg-icon/icons/warning-icon.js